import { Video, Headphones } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function VideoCallButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/sofort-besichtigung');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-44 right-6 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40 group"
      aria-label="Video-Besichtigung buchen"
    >
      <div className="absolute -top-2 -right-2 bg-red-500 text-white p-1.5 rounded-full shadow-lg animate-pulse">
        <Headphones className="w-4 h-4" />
      </div>
      <Video className="w-6 h-6 group-hover:scale-110 transition-transform" />
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
        <div className="bg-slate-900 text-white px-4 py-3 rounded-lg text-sm font-medium shadow-xl whitespace-normal max-w-[250px]">
          <div className="font-bold mb-1">Zeit für eine spontane Besichtigung?</div>
          <div className="text-xs text-slate-300">Wir sind jetzt online und können Sie gleich bedienen!</div>
        </div>
      </div>
    </button>
  );
}
